module.exports = __webpack_public_path__ + "static/media/travisgo_tablet_bg_businesspartner.40b4ba39.webp";